export const checkoutMessages = {
  quotePending: "Estamos preparando el resumen de tu curso…",
  quoteError: "No pudimos calcular el precio de estos cursos.",
  quoteRecovery: "Vuelve al catálogo y elige un curso disponible.",
  emptyTitle: "Tu selección está vacía",
  emptyBody: "Elige un curso y vuelve aquí para continuar.",
  catalog: "Ver los cursos",
  ownedTitle: "Este aprendizaje ya es tuyo",
  ownedBody: "Estos cursos ya están en tu cuenta y no se volverán a cobrar.",
  access: "Acceso al curso completo",
  lessons: (count: number) =>
    `${count} ${count === 1 ? "clase" : "clases"} · Acceso completo`,
  codeLabel: "¿Tienes un código de descuento?",
  codePlaceholder: "Escribe tu código",
  codeApply: "Aplicar",
  codeApplying: "Validando…",
  codeRemove: "Quitar",
  codeApplied: (percent: number) => `${percent}% de descuento aplicado`,
  codeInvalid: "Ese código no es válido o ya fue usado.",
  codeError: "No pudimos validar el código. Inténtalo de nuevo.",
  codeExpired: "El código dejó de ser válido. Quítalo para continuar.",
  // Why the server refused a code (coupons.ts CouponRejection).
  codeReasons: {
    not_found: "Ese código no existe. Revisa que esté bien escrito.",
    disabled: "Ese código ya no está activo.",
    paused: "Esta promoción está pausada por ahora.",
    not_started: "Esta promoción todavía no empieza.",
    expired: "Esta promoción ya terminó.",
    used: "Ese código ya fue usado.",
    exhausted: "Esta promoción ya no tiene cupos disponibles.",
    user_limit: "Ya usaste esta promoción con este correo.",
    first_purchase_only: "Este código es solo para tu primera compra.",
    not_applicable: "Este código no aplica a los cursos de tu selección.",
    below_minimum:
      "Tu selección no alcanza la compra mínima de esta promoción.",
    below_provider_minimum:
      "Con este código el total queda por debajo del mínimo que podemos cobrar.",
  } as Record<string, string>,
  codeAppliedSome: (percent: number) =>
    `${percent}% de descuento en los cursos de la promoción`,
  subtotal: "Subtotal",
  discount: "Descuento",
  total: "Total a pagar",
  priceWas: "Antes",
  quoteAuthority: "El precio y la moneda se confirman antes del pago.",
  accountNote:
    "Con ese correo creamos tu cuenta: ahí quedan tu curso, tu progreso y tu certificado.",
  signedIn: "Ya estás dentro",
  signedInBody:
    "Tu curso quedará vinculado a esta cuenta. Continúa para revisar el pago.",
  changeAccount: "Usar otra cuenta",
  changingAccount: "Cambiando de cuenta…",
  signOutError: "No pudimos cerrar tu sesión. Inténtalo de nuevo.",
  email: "Tu correo electrónico",
  emailPlaceholder: "tu@correo.com",
  emailHelp:
    "Ahí te enviamos el acceso y un código para activar tu cuenta. Revisa que esté bien escrito.",
  emailInvalid: "Escribe un correo válido, como nombre@gmail.com.",
  emailOwnsCourse:
    "Ese correo ya tiene este curso. Inicia sesión con él para verlo.",
  validationError: "Revisa los campos marcados para continuar.",
  existingAccount: "¿Ya tienes una cuenta?",
  login: "Inicia sesión",
  pay: "Pagar y obtener acceso",
  paying: "Abriendo el pago seguro…",
  // A 100% coupon: no payment step at all.
  payFree: "Obtener acceso gratis",
  payingFree: "Activando tu acceso…",
  secureFree: "Tu código cubre el total: no te pediremos ningún pago.",
  paymentError: "No pudimos iniciar el pago. Inténtalo de nuevo.",
  secure: "Pago seguro procesado por Stripe",
} as const;
export const checkoutLandingUrl =
  import.meta.env.VITE_LANDING_URL || "https://hey404.com/#cursos";
